import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';

import { ResetPasswordForm } from './-components/reset-password-form';

const resetPasswordSearchSchema = z.object({
  email: z.string().optional(),
});

export const Route = createFileRoute('/_auth/reset-password/')({
  component: RouteComponent,
  validateSearch: resetPasswordSearchSchema,
  head: () => ({
    meta: [{ title: 'FeatureBuddy - Reset Password' }],
  }),
});

function RouteComponent() {
  return (
    <div>
      <ResetPasswordForm />
    </div>
  );
}
